<template>
  <div>
    The page is not found
  </div>
</template>

<script>

export default {
  name: 'NotFound',
  mounted: function () {
    document.title = 'Not Found'
  }
}
</script>

<style scoped></style>
